import React from 'react';
export const LegendRiskHighIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={22}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="5" y="4" width="14" height="14" fill="#EA3829" />
  </svg>
);
